import { Record } from 'immutable';
import memoize from 'transmute/memoize';
export const validName = memoize(name => {
  return typeof name === 'string' && name.trim() !== '';
});

// @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
export default new Record({
  firstName: undefined,
  lastName: undefined,
  hasEditEmail: undefined,
  emailAddress: undefined,
  emailHash: undefined,
  pendingEmailAddress: undefined,
  loginEmails: undefined,
  canSelfDelete: undefined,
  scim: false
}, 'UserProfile');